/* eslint-disable */
// @ts-nocheck
import debugLib from 'debug';
import { reducerWrapper } from '../support/utils';
import { GET_ACCOUNTS, CONFIGURE_ACCOUNTS, RESET_ACCOUNTS, UPDATE_TWITTER_AD_ACCOUNTS } from '../actions/TwitterActions';
import type { TwitterReducer } from '../types/adPartnerTypes';
import '../types/adPartnerTypes';
const debug = debugLib('TwitterReducer');
export function createInitialState() {
  return {
    accounts: [],
    loading: false,
    error: null,
  };
}

function Handler(state: TwitterReducer = createInitialState(), action) {
  debug('Receive action type', action.type);

  switch (action.type) {
    case CONFIGURE_ACCOUNTS.response:
    case GET_ACCOUNTS.response:
      const { accounts } = action.data;
      return { ...state, accounts, loading: false, error: null };

    case UPDATE_TWITTER_AD_ACCOUNTS: {
      const data = action.data;
      const accounts = state.accounts.map((account) => {
        if (!data.ids?.includes(account.id)) {
          return account;
        }

        return { ...account, checked: data.checked };
      });
      return { ...state, accounts };
    }

    default:
      return state;
  }
}

const Twitter = reducerWrapper(createInitialState(), Handler, {
  request: [GET_ACCOUNTS, CONFIGURE_ACCOUNTS, RESET_ACCOUNTS],
  error: [GET_ACCOUNTS, CONFIGURE_ACCOUNTS, RESET_ACCOUNTS],
  resetOn: ['APP_CHANGE'],
});
export default Twitter;
